import React, { useEffect } from "react";
import { Autocomplete, Icon } from "react-materialize";
import { useDispatch, useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import { addProduct } from "../redux/actions/products";
import { getALlBranches, getBranch } from "../redux/actions/branches";

const AddProduct = ({ setShowProductModal, branchId }) => {
  const { branches } = useSelector((state) => state.branch);
  const { account } = useSelector((state) => state.auth);
  const { loading } = useSelector((state) => state.product);
  const [values, setValues] = React.useState({
    name: "",
    manufacturer: "",
    nickname: "",
    type: "",
    size: "",
    factoryPrice: "",
    branches: [],
  });
  const [chipData, setChipData] = React.useState([]);
  const [autocompleteData, setAutocompleteData] = React.useState({});
  const dispatch = useDispatch();
  const handleAutocomplete = (value) => {
    if (chipData.includes(value)) return;
    setChipData([...chipData, value]);
  };

  useEffect(() => {
    let data = {};
    branches.forEach((branch) => {
      data[branch.name] = branch._id;
    });
    setAutocompleteData(data);

    if (account.branches.length === 1) {
      const branch = branches.find(
        (branch) => branch._id === account.branches[0]
      );
      setChipData([branch.name]);
    }
  }, [account.branches, branches]);

  const send = (e) => {
    e.preventDefault();

    const product = {
      name: values.name,
      manufacturer: values.manufacturer,
      nickname: values.nickname,
      type: values.type,
      size: values.size,
      factoryPrice: values.factoryPrice,
      branches: branches
        .filter((branch) => chipData.includes(branch.name))
        .map((branch) => branch._id),
    };

    dispatch(
      addProduct(product, () => {
        setValues({
          name: "",
          manufacturer: "",
          nickname: "",
          type: "",
          size: "",
          factoryPrice: "",
          branches: [],
        });
        setChipData([]);
        setShowProductModal(false);
        if (branchId) dispatch(getBranch(branchId));
      })
    );
  };

  return (
    <form onSubmit={send} className="mt-2 p-2 ">
      <h4>Add A New Product</h4>

      <div className="mb-2">
        <p>
          Enter Product Name
          <span className="red-text"> * </span>
        </p>
        <input
          type="text"
          className="browser-default
               custom-text-input"
          placeholder="Eg. Paracetamol Tab"
          value={values.name}
          onChange={(e) => setValues({ ...values, name: e.target.value })}
          required
        />
      </div>

      <div className="mb-2">
        <p>Enter Product Nickname or Other Names </p>
        <input
          type="text"
          className="browser-default
               custom-text-input"
          placeholder="Eg. Para"
          value={values.nickname}
          onChange={(e) => setValues({ ...values, nickname: e.target.value })}
        />
      </div>

      <div className="mb-2">
        <p>
          Enter Product Manufacturer
          <span className="red-text"> * </span>
        </p>
        <input
          type="text"
          className="browser-default
               custom-text-input"
          placeholder="Eg. Letap Pharmaceuticals"
          value={values.manufacturer}
          onChange={(e) =>
            setValues({ ...values, manufacturer: e.target.value })
          }
          required
        />
      </div>

      <div className="mb-2">
        <p>
          Choose Product Type
          <span className="red-text"> * </span>
        </p>
        <select
          className="browser-default custom-select"
          required
          onChange={(e) => setValues({ ...values, type: e.target.value })}
        >
          <option value="" selected>
            Select Product Type
          </option>
          <option value="Tablet">Tablet</option>
          <option value="Capsule">Capsule</option>
          <option value="Syrup">Syrup</option>
          <option value="Injection">Injection</option>
          <option value="Cream">Cream</option>
          <option value="Powder">Powder</option>
          <option value="Drops">Drops</option>
          <option value="Ointment">Ointment</option>
          <option value="Gel">Gel</option>
          <option value="Lotion">Lotion</option>
          <option value="Suspension">Suspension</option>
          <option value="Solution">Solution</option>
          <option value="Aerosol">Aerosol</option>
          <option value="Mouth Wash">Mouth Wash</option>
          <option value="Shampoo">Shampoo</option>
          <option value="Soap">Soap</option>
          <option value="Spray">Spray</option>
          <option value="Drops">Drops</option>
          <option value="Oil">Oil</option>
          <option value="Suppository">Suppository</option>
          <option value="Sachet">Sachet</option>
          <option value="mixture">mixture</option>
        </select>
      </div>

      <div className="mb-2">
        <p>Enter Product Size </p>
        <input
          type="text"
          className="browser-default
               custom-text-input"
          placeholder="Eg. 500ml (Medium Size)"
          value={values.size}
          onChange={(e) => setValues({ ...values, size: e.target.value })}
        />
      </div>

      <div className="mb-2">
        <p>Enter Product Factory Price </p>
        <input
          type="number"
          className="browser-default
               custom-text-input"
          placeholder="Eg. 10.00"
          value={values.factoryPrice}
          onChange={(e) =>
            setValues({ ...values, factoryPrice: e.target.value })
          }
          min="0"
          step="0.01"
        />
      </div>

      {account?.branches?.length > 1 && (
        <div className="mb-2">
          <p>Choose Branches To Add Product To </p>
          <Autocomplete
            options={{
              data: autocompleteData,
              onAutocomplete: (value) => handleAutocomplete(value),
            }}
          />
          {chipData.map((chip, index) => (
            <div className="chip">
              {chip}
              <i
                className="close material-icons"
                onClick={() =>
                  setChipData(
                    chipData.filter((chip) => chip !== chipData[index])
                  )
                }
              >
                close
              </i>
            </div>
          ))}
        </div>
      )}

      <button className="btn" type="submit">
        {loading ? (
          <ClipLoader color="#fff" size={20} />
        ) : (
          <span>
            <Icon left>add</Icon> Add Product
          </span>
        )}
      </button>
    </form>
  );
};

export default AddProduct;
